module.exports = __webpack_public_path__ + "static/media/team_management_fallback.c820f8e9.svg";